<div class="bg-white"><router-outlet></router-outlet></div>